import React from "react";
import { StatCard, DonutWithLegend } from "@/components/ui";
import { Maximize2, Minimize2, IndianRupee } from "lucide-react";

const fmt = (v) => new Intl.NumberFormat("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(v);

export const ProjectsStats = ({ stats = {}, isExpanded, onToggle }) => {
  const {
    totalProjects,
    inProgress,
    completed,
    totalQuoted,
    statusBreakdown,
    sourceBreakdown
  } = stats;

  return (
    <div className="space-y-4 relative group/stats">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 auto-rows-fr">
        <StatCard
          variant="luxury"
          title="Total Projects"
          value={totalProjects || 0}
          sub="All projects in the system"
          topColor="border-t-[#5d6b8b]"
          iconHoverColor="group-hover:text-[#ffa000]"
          illustration={<svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" /></svg>}
        />

        <StatCard
          variant="luxury"
          title="In Progress"
          value={inProgress || 0}
          sub="Projects in development"
          topColor="border-t-[#5d6b8b]"
          iconHoverColor="group-hover:text-[#ffa000]"
          illustration={<svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" /></svg>}
        />

        <StatCard
          variant="luxury"
          title="Completed"
          value={completed || 0}
          sub="Successfully finished"
          topColor="border-t-[#5d6b8b]"
          iconHoverColor="group-hover:text-[#ffa000]"
          illustration={<svg className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" /></svg>}
        />

        <StatCard
          variant="luxury"
          title="Estimated Budget"
          value={fmt(totalQuoted || 0)}
          sub="Aggregate quotation value"
          topColor="border-t-[#5d6b8b]"
          iconHoverColor="group-hover:text-[#ffa000]"
          illustration={<IndianRupee className="w-10 h-10" strokeWidth={2} />}
        />
      </div>
    </div>
  );
};
